var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-12 col-md-4 name" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Название учебного заведения",
                clearable: true,
                "max-length": 255,
                required: _vm.error && _vm.error.institution,
                "required-message": _vm.error && _vm.error.institution,
              },
              model: {
                value: _vm.value.institution,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "institution", $$v)
                },
                expression: "value.institution",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 col-md-4 specialization" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "Специальность",
                clearable: true,
                "max-length": 255,
                required: _vm.error && _vm.error.specialization,
                "required-message": _vm.error && _vm.error.specialization,
              },
              model: {
                value: _vm.value.specialization,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "specialization", $$v)
                },
                expression: "value.specialization",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "col col-2 sm d-none d-md-block d-lg-none remove-md" },
        [
          _vm.canRemove
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: { size: "iconic", icon: "trash" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "col col-12 col-md-2 years" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("div", { staticClass: "c-input-label" }, [
              _vm._v("Год поступления — окончания"),
            ]),
            _c("div", { staticClass: "years__wrapper" }, [
              _c(
                "div",
                { staticClass: "years__from" },
                [
                  _c("c-input", {
                    attrs: {
                      clearable: true,
                      "max-length": 4,
                      type: "price-number",
                      placeholder: "0000",
                      "fractional-length": 0,
                      invalid:
                        _vm.error && (_vm.error.from || _vm.error.period),
                    },
                    model: {
                      value: _vm.value.from,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "from", $$v)
                      },
                      expression: "value.from",
                    },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "years__divider" }, [_vm._v("–")]),
              _c(
                "div",
                { staticClass: "years__to" },
                [
                  _c("c-input", {
                    attrs: {
                      clearable: true,
                      "max-length": 4,
                      type: "price-number",
                      placeholder: "0000",
                      "fractional-length": 0,
                      invalid: _vm.error && (_vm.error.to || _vm.error.period),
                    },
                    model: {
                      value: _vm.value.to,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "to", $$v)
                      },
                      expression: "value.to",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm.error && (_vm.error.period || _vm.error.from || _vm.error.to)
              ? _c("error-feedback", {
                  attrs: {
                    text:
                      _vm.error &&
                      (_vm.error.period || _vm.error.from || _vm.error.to),
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "col col-12 d-md-none" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _vm.canRemove
              ? _c("c-button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover blur",
                        content: "Удалить",
                        placement: "top",
                      },
                      expression:
                        "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: 'Удалить',\n            placement: 'top',\n          }",
                      modifiers: { html: true },
                    },
                  ],
                  attrs: { size: "small", label: "Удалить", icon: "trash" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("remove")
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "col col-1 remove lg d-none d-lg-block" },
        [
          _vm.canRemove
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Удалить',\n          placement: 'top',\n        }",
                    modifiers: { html: true },
                  },
                ],
                attrs: { size: "iconic", icon: "trash" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }